// <s-scroll-steps> pins a nested <s-slideshow> while the page scrolls through its tall
// wrapper and advances one slide per scroll step. Manual arrows, dots and swipes still
// work: the slide only changes from scrolling when the scroll step itself changes.
class SScrollSteps extends HTMLElement {
  #ac;
  #raf = 0;
  #step = -1;
  #slideshow;

  connectedCallback() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    // Phones are too short to pin a full slide; they get a normal swipeable slideshow at natural height.
    if (!window.matchMedia('(min-width: 48rem)').matches) return;
    this.#slideshow = this.querySelector('s-slideshow');
    if (!this.#slideshow) return;

    const total = this.#slideshow.querySelectorAll('[data-slide]').length;
    if (total < 2) return;
    this.style.setProperty('--steps', String(total));
    this.setAttribute('data-scroll-active', '');

    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal, passive: true };
    window.addEventListener('scroll', this.#schedule, opts);
    window.addEventListener('resize', this.#schedule, opts);
    this.#schedule();
  }

  disconnectedCallback() {
    this.#ac?.abort();
    cancelAnimationFrame(this.#raf);
  }

  #schedule = () => {
    cancelAnimationFrame(this.#raf);
    this.#raf = requestAnimationFrame(this.#update);
  };

  #update = () => {
    const slideshow = this.#slideshow;
    if (!slideshow || typeof slideshow.select !== 'function') return;
    const total = slideshow.querySelectorAll('[data-slide]').length;
    const rect = this.getBoundingClientRect();
    const travel = rect.height - window.innerHeight;
    if (travel <= 0) return;
    const p = Math.min(Math.max(-rect.top / travel, 0), 0.9999);
    const step = Math.floor(p * total);
    if (step !== this.#step) {
      const first = this.#step === -1;
      this.#step = step;
      // Don't move the slideshow on the initial read unless the page loaded mid-section.
      if (!first || step > 0) slideshow.select(step);
    }
  };
}

if (!customElements.get('s-scroll-steps')) customElements.define('s-scroll-steps', SScrollSteps);
